import { FC } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import {
  LocationSection as StyledLocationSection,
  LocationHeader,
  LocationTitle,
  RemoveLocationButton,
} from '../CustomersSettingsPage.styled';
import { LocationFormFields } from './LocationFormFields';
import { ChangeFunctionType } from '@bookjane2/bookjane-design-library/lib/common.types';
import { FormValuesType } from 'types/common.types';
import { Flex } from 'components/Flex';

interface LocationSectionProps {
  location: FormValuesType;
  index: number;
  onLocationChange: ChangeFunctionType;
  onRemoveLocation: () => void;
  showRemoveButton?: boolean;
}

export const LocationSection: FC<LocationSectionProps> = ({
  location,
  index,
  onLocationChange,
  onRemoveLocation,
  showRemoveButton = true,
}) => {
  const { t } = useTranslation();

  return (
    <StyledLocationSection isAlternate={index % 2 === 1}>
      <LocationHeader>
        <LocationTitle>
          {t('location_settings:LOCATION')} {index + 1}
        </LocationTitle>
      </LocationHeader>

      <LocationFormFields location={location} onLocationChange={onLocationChange} />
      {showRemoveButton && index > 0 && (
        <Flex padding="20px 0 0 10px">
          <RemoveLocationButton variant="PurpleText" type="button" onClick={onRemoveLocation}>
            {t('location_settings:REMOVE_CUSTOMER_LOCATION_BUTTON')}
          </RemoveLocationButton>
        </Flex>
      )}
    </StyledLocationSection>
  );
};
